import React, {FC, useContext, useEffect, useState} from "react";
import {ContextAppState} from "@app/context.ts";
import Decimal from "decimal.js";
import {TokenWithAmount} from "./index.tsx";
import {useSendToken} from "@hooks/request.ts";
import {Button} from "@components/ui/button.tsx";

export type SendProps = {
    tokenWithAmount: TokenWithAmount;
};

export const Send: FC<SendProps> = ({tokenWithAmount}) => {
    const [recipient, setRecipient] = useState("");
    const [amount, setAmount] = useState("");
    const [sending, setSending] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const appState = useContext(ContextAppState);
    const [sendToken, setSendToken] = useSendToken();

    // useEffect(() => {
    //     if (appState.type === 'Telegram') {
    //         // @ts-ignore
    //         const tg = window.Telegram.WebApp;
    //         tg.BackButton.show();
    //         const handleBackClick = () => {
    //             window.history.back();
    //         };
    //         tg.BackButton.onClick(handleBackClick);
    //
    //         return () => {
    //             tg.BackButton.hide();
    //             tg.BackButton.offClick(handleBackClick);
    //         };
    //     }
    // }, [appState.type]);


    const isValidAddress = (address: string) => {
        return address.length > 30; // basic check, replace with real validator if needed
    };

    const isValidAmount = (amount: string) => {
        const parsed = new Decimal(amount);
        return !parsed.isNaN() && parsed > new Decimal(0) && parsed <= tokenWithAmount.amount;
    };

    const handleSend = async () => {
        setError("");
        setSuccess("");

        if (!isValidAddress(recipient)) {
            setError("Invalid Solana address");
            return;
        }

        if (!isValidAmount(amount)) {
            setError("Invalid or insufficient amount");
            return;
        }

        try {
            setSending(true);
            // await onSend(recipient, parseFloat(amount), memo);
            // sendToken(appState.wallet.id, {
            //     to: recipient,
            //     amount: amount,
            //     mint: tokenWithAmount.token.mint
            // })
            setSuccess("Transaction sent successfully!");
            // setRecipient("");
            // setAmount("");
        } catch (err) {
            setError("Transaction failed");
        } finally {
            setSending(false);
        }
    };

    return (
        <div
            className="max-w-md mx-auto mt-12 bg-gradient-to-br from-blue-100 via-blue-50 to-pink-50 border border-orange-200/60 rounded-3xl p-6 shadow-xl space-y-6 backdrop-blur-md"
        >
            <h1 className="text-2xl font-bold text-orange-700 text-center">
                Send {tokenWithAmount.token.symbol}
            </h1>

            <div className="text-sm text-center text-gray-700 font-mono">
                You have{" "}
                <span className="font-semibold text-orange-600">
            {tokenWithAmount.amount.toFixed(4)} {tokenWithAmount.token.symbol}
        </span>
            </div>

            <div className="space-y-1">
                <label className="text-sm text-orange-700 font-medium">
                    Recipient Address
                </label>
                <input
                    type="text"
                    value={recipient}
                    onChange={(e) => setRecipient(e.target.value)}
                    placeholder="Enter Solana address"
                    className="w-full px-4 py-2 border border-orange-200 rounded-xl bg-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
                />
            </div>

            <div className="space-y-1">
                <label className="text-sm text-orange-700 font-medium">
                    Amount (SOL)
                </label>
                <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="0.0"
                    min="0"
                    step="any"
                    className="w-full px-4 py-2 border border-orange-200 rounded-xl bg-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
                />
            </div>

            {error && (
                <div className="text-sm text-red-500 text-center">{error}</div>
            )}

            {success && (
                <div className="text-sm text-green-600 text-center">{success}</div>
            )}

            <Button
                disabled={sending}
                onClick={handleSend}
                className={`w-full py-2 rounded-xl text-white font-semibold text-sm transition ${
                    sending
                        ? "bg-orange-300 cursor-not-allowed"
                        : "bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 hover:brightness-110 shadow-md"
                }`}
            >
                {sending ? "Sending..." : "Send SOL"}
            </Button>
        </div>
    );
};
